// Minimal canvas signature pad (no external lib). Registers an Alpine component "signaturePad"
// that captures strokes and posts the PNG data URL to the given save URL.
import type { Alpine } from "alpinejs";

export function registerSignature(alpine: Alpine): void {
  alpine.data("signaturePad", (saveUrl: string) => ({
    drawing: false,
    dirty: false,
    saved: false,
    error: "",
    ctx: null as CanvasRenderingContext2D | null,
    canvas: null as HTMLCanvasElement | null,

    init() {
      const canvas = this.$refs.canvas as HTMLCanvasElement;
      this.canvas = canvas;
      // Match the backing store to the CSS size for crisp lines.
      const rect = canvas.getBoundingClientRect();
      canvas.width = rect.width;
      canvas.height = rect.height;
      const ctx = canvas.getContext("2d");
      if (!ctx) return;
      ctx.lineWidth = 2.2;
      ctx.lineCap = "round";
      ctx.strokeStyle = "#111827";
      this.ctx = ctx;
    },

    pos(e: PointerEvent) {
      const r = this.canvas!.getBoundingClientRect();
      return { x: e.clientX - r.left, y: e.clientY - r.top };
    },

    start(e: PointerEvent) {
      this.drawing = true;
      this.dirty = true;
      const p = this.pos(e);
      this.ctx!.beginPath();
      this.ctx!.moveTo(p.x, p.y);
    },
    move(e: PointerEvent) {
      if (!this.drawing) return;
      const p = this.pos(e);
      this.ctx!.lineTo(p.x, p.y);
      this.ctx!.stroke();
    },
    end() {
      this.drawing = false;
    },

    clear() {
      this.ctx!.clearRect(0, 0, this.canvas!.width, this.canvas!.height);
      this.dirty = false;
    },

    async save(signerName: string, confirmed?: boolean) {
      if (!this.dirty) {
        this.error = "יש לחתום קודם";
        return;
      }
      this.error = "";
      const image = this.canvas!.toDataURL("image/png");
      const body = new URLSearchParams();
      body.set("image", image);
      body.set("signerName", signerName || "");
      // Per-passenger form passes the terms-consent flag; lead-level form omits it.
      if (confirmed !== undefined) body.set("confirmed", confirmed ? "true" : "false");
      try {
        const res = await fetch(saveUrl, {
          method: "POST",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          body: body.toString(),
        });
        const data = await res.json();
        if (data.ok) this.saved = true;
        else this.error = data.error || "שמירה נכשלה";
      } catch {
        this.error = "שגיאת רשת";
      }
    },
  }));
}
